<template>
  <BCard no-body v-draggable class="popup text-dark">
    <BCardHeader
      style="height: 25px; user-select: none;"
      class="ps-2 pb-0 pt-0"
      header-tag="div"
    >
      <BRow class="mx-0 px-0">
        <BCol class="mx-0 px-0" cols="11">
          {{!edit ? 'Unterprojekt erstellen' : 'Unterprojekt bearbeiten'}}
          <FontAwesomeIcon 
            v-if="subProjectHistory"
            class="mx-2 clickable"
            icon="fa-solid fa-book"
            style="cursor:pointer;"
            @click="showHistory = !showHistory"
          />
        </BCol>
        <BCol class="mx-0 px-0" cols="1" style="display: flex; justify-content: end;">
          <div @click="$emit('close')">
            <FontAwesomeIcon
              class="mx-1 clickable"
              icon="fa-solid fa-xmark"
              style="cursor:pointer;"
            />
          </div>

        </BCol>
      </BRow>
    </BCardHeader>

    <BCardBody style="overflow-y: auto;">
      <BForm @submit="onSubmit">
        <BRow>
          <BCol>
            <label for="input-project">Kunde/Projekt:</label>
            <treeselect 
              id="input-project"
              v-model="subProject.ProjectId" 
              placeholder="Kunde/Projekt..."
              :options="clientProjectList_treeselect"
              :multiple="false"
              :disable-branch-nodes="true"
              required
              :disabled="edit"
              :max-height="200"
            />
          </BCol>
          <BCol>
            <BFormGroup
              label="Unterprojekt-Name:"
              label-for="input-name"
            >
              <BFormInput
                id="input-name"
                v-model="subProject.SubProjectName"
                type="text"
                placeholder="Unterprojekt-Name..."
                :state="subProjectNameAvailable"
                @blur="getSubProjectNameAvailable()"
                required
              ></BFormInput>
              <BFormInvalidFeedback id="input-name">
                Name bereits vergeben.
              </BFormInvalidFeedback>
            </BFormGroup>
          </BCol>
        </BRow>
        <hr>
        <BRow>
          <BCol>
            <BFormGroup
              label="Consultant:"
              label-for="input-vl"
            >
              <BFormInput
                id="input-vl"
                type="text"
                v-model="subProject.Consultant"
                placeholder="Consultant..."
                lazy-formatter
                :formatter="formatterConsultant"
                required
              ></BFormInput>
            </BFormGroup>
          </BCol>
          <BCol>
            <BFormGroup
              label="Wahrscheinlichkeit (%):"
              label-for="input-odds"
            >
              <BFormSelect
                id="input-probability"
                v-model="subProject.Probability"
                :options="probabilityList"
                placeholder="Wahrscheinlichkeit..."
                required
              ></BFormSelect>
            </BFormGroup>
          </BCol>
        </BRow>
        <hr>
        <BRow>
          <BCol style="margin: auto;" v-if="edit">
            <BButton class="m-2" variant="outline-danger" @click="showDeletePopup = true">
              <FontAwesomeIcon
                class="mx-1 clickable"
                icon="fa-solid fa-trash"
                style="font-size: 14pt;"
              />
              <span>Löschen</span>
            </BButton>
            <BButton class="m-2" variant="outline-success" @click="showArchivePopup = true">
              <FontAwesomeIcon
                class="mx-1 clickable"
                icon="fa-solid fa-box-archive"
                style="font-size: 14pt;"
              />
              <span>Archivieren</span>
            </BButton>
          </BCol>
          <BCol style="text-align:end">
            <BButton class="m-2" type="submit" variant="primary" :disabled="formChanges === 0 || subProjectNameAvailable === false">Speichern</BButton>
            <BButton class="m-2" @click="$emit('close')" variant="secondary">Abbrechen</BButton>
          </BCol>
        </BRow>
      </BForm>
    </BCardBody>

    <!-- History Popup -->
    <GenericPopup v-if="showHistory" @close="showHistory = false">
      <div v-for="e in subProjectHistory" :key="e.index">
        {{e.FirstName}} {{e.LastName}} {{e.Timestamp}}: 
        <br>
        {{e.SubProjectJson}}
        <hr>
      </div>
    </GenericPopup>

    <!-- Delete Popup -->
    <GenericPopup v-if="showDeletePopup" @close="showDeletePopup = false" width="25vw">
      <BCol>
        <BRow style="display: flex;justify-content: center;text-align: center;">
          <span v-if="!subProject.HasSalary">Soll das Unterprojekt gelöscht werden?</span>
          <span v-else-if="subProject.HasSalary">
            Es gibt Zeiteinträge für dieses Unterprojekt.
            <br> Es kann nicht gelöscht werden.
          </span>
        </BRow>
        <BRow style="display: flex;justify-content: center; align-items:center">
          <FontAwesomeIcon 
            v-if="subProject.HasSalary"
            class="mx-2"
            icon="fa-solid fa-lock"
          />
          <BButton class="m-2" variant="danger" @click="setSubProjectInactive()" :disabled="subProject.HasSalary">Löschen</BButton>
          <BButton class="m-2" @click="showDeletePopup = false" >Abbrechen</BButton>
        </BRow>
      </BCol>
    </GenericPopup>

    <!-- Archive Popup -->
    <GenericPopup v-if="showArchivePopup" @close="showArchivePopup = false" width="25vw">
      <BCol>
        <BRow style="display: flex;justify-content: center;text-align: center;">
          Soll das Unterprojekt archiviert werden?
        </BRow>
        <BRow style="display: flex;justify-content: center;">
          <BButton class="m-2" variant="success" @click="setSubProjectIsArchived()">Archivieren</BButton>
          <BButton class="m-2" @click="showArchivePopup = false" >Abbrechen</BButton>
        </BRow>
      </BCol>
    </GenericPopup>
  </BCard>
</template>

<script>
import AuthenticationService from '../services/AuthenticationService';
import ControllingService from '../services/ControllingService';

import Treeselect from '@zanmato/vue3-treeselect'

import GenericPopup from './GenericPopup';

export default {
  name: "SubProjectEditPopup",

  emits: ['close', 'close-reload'],

  components: {
    GenericPopup,
    Treeselect,
  },
  props: {
    clientProjectList_treeselect: {
      type: Array,
      default: () => []
    },

    edit: {
      type: Boolean,
      default: false
    },

    selectedSubproject: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      clientCode: {
        ClientCode: null,
        SubProjectCode: null,
      },
      clientCodeLocked: false,
      countryList: null,
      formChanges: 0,
      probabilityList: [],
      showArchivePopup: false,
      showDeletePopup: false,
      showHistory: false,
      subProject: {
        SubProjectId: null,
        ProjectId: null,
        SubProjectName: null,
        SubProjectCode: null,
        Consultant: null,
        Probability: null,
      },
      subProjectHistory: null,
      subProjectNameAvailable: null
    }
  },
  mounted() {
    var enableSave = false;
    if(this.selectedSubproject && this.edit){
      this.subProject = JSON.parse(JSON.stringify(this.selectedSubproject));

      // get SubProject History
      if(this.hasPermission('Management')) {
        ControllingService.getSubprojectHistory(this.selectedSubproject.SubProjectId)
        .then(res => {
          if(res.data) {
            this.subProjectHistory = res.data;
            this.subProjectHistory.forEach(h => {
              h.SubProjectJson = JSON.parse(h.SubProjectJson);
            });
          }
        });
      }
    }
    
    // getCountryList for country selector
    ControllingService.getCountryList()
    .then(res => {
      this.countryList = res.data;
      
      // unshift placeholder
      this.countryList.unshift({ value: null, text: 'Land...', disabled: true})
    });

    // if its an existing SubProject 
    switch (this.subProject.Probability) {
      case 0:
        this.probabilityList = [
          {text: '0% (Angebot abgelehnt)', value: 0},
          {text: '50% (Angebot bei Kunde)', value: 50},
          {text: '100% (Angebot angenommen)', value: 100},
        ];
        break;
      case 50:
        this.probabilityList = [
          {text: '0% (Angebot abgelehnt)', value: 0},
          {text: '50% (Angebot bei Kunde)', value: 50},
          {text: '100% (Angebot angenommen)', value: 100},
        ];
        break;
      case 100:
        this.probabilityList = [
          {text: '0% (Angebot abgelehnt)', value: 0},
          {text: '50% (Angebot bei Kunde)', value: 50},
          {text: '100% (Angebot angenommen)', value: 100},
        ];
        break;
      default:
        this.probabilityList = [
          {disabled: true, text: 'Wahrscheinlichkeit...', value: null},
          {text: '0% (Angebot abgelehnt)', value: 0},
          {text: '50% (Angebot bei Kunde)', value: 50},
          {text: '100% (Angebot angenommen)', value: 100},
        ]
        break;
    }
    
    // wait for all to be mounted
    setTimeout(() => {
      this.formChanges = 0;
      if(enableSave) this.formChanges++
    }, 100);
  },
  watch: {
    'subProject.ProjectId'() {
      var selectedClient = this.clientProjectList_treeselect.find(client => client.children.find(project => project.id === this.subProject.ProjectId ));
      if(selectedClient) {
        if(selectedClient.clientCode) {
          this.clientCodeLocked = true;
          this.clientCode.ClientCode = selectedClient.clientCode;
        } else {
          this.clientCodeLocked = false;
          this.clientCode.ClientCode = null;
        }
        this.clientCode.ClientId = selectedClient.id;
      } else {
        this.clientCodeLocked = false;
        this.clientCode.ClientCode = null;
        this.clientCode.ClientId = null;
      }
    },
    subProject: {
      handler() {
        this.formChanges++;
      },
      deep: true
    },
  },
  methods: {
    formatterConsultant(value) {
      let threeChars = /^[a-zA-Z]{3}$/;
      let twoChars = /^[a-zA-Z]{2}$/;

      if(threeChars.test(value)) return value;
      if(twoChars.test(value)) return value;
      
      return '';
    },
    hasPermission(permission) {
      return AuthenticationService.hasPermission(permission);
    },
    getSubProjectNameAvailable() {
      if(this.formChanges > 0 && this.subProject.ProjectId && this.subProject.SubProjectName) {
        ControllingService.getSubProjectNameAvailable({ProjectId: this.subProject.ProjectId, SubProjectId: this.subProject.SubProjectId, SubProjectName: this.subProject.SubProjectName})
        .then(res => {
          if(!res.data.SubProjectNameAvailable) {
            this.subProjectNameAvailable = false;
          } else {
            this.subProjectNameAvailable = null;
          }
        })
      }
    },
    onSubmit(event) {
      event.preventDefault()
      this.validateSubProject();
      ControllingService.setSubProject(this.subProject)
      .then(() => {
        if(this.subProject.Probability == 100) {
          ControllingService.setClientCode(this.clientCode)
          .then(() => {
            this.$emit('close-reload');
          })
        } else {
          this.$emit('close-reload');
        }
      });
    },
    setSubProjectInactive() {
      ControllingService.setSubprojectInactive(this.subProject.SubProjectId)
      .then(() => {
        this.$emit('close-reload');
      })
    },
    setSubProjectIsArchived() {
      ControllingService.setSubprojectIsArchived(this.subProject.SubProjectId, true)
      .then(() => {
        this.$emit('close-reload');
      })
    },
    validateSubProject() {
      // remove empty strings
      for (var prop in this.subProject) {
        if (Object.prototype.hasOwnProperty.call(this.subProject, prop)) {
          if(this.subProject[prop] === '') this.subProject[prop] = null;
        }
      }
    },
  },
}
</script>

<style scoped>
.popup {
  width: 80vw;
  max-height: 80%;
  position: fixed !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
}
</style>